import {LocalStorage} from '@js/LocalStorage';
import {difference, uniq} from 'lodash';
import {formQueryString, getUrlParameter} from '@js/helpers/location';

const lang = {
    add_to_cart_title: 'Добавить к сравнению',
    remove_from_cart_title: 'Убрать из сравнения',
};

// TODO-misha вынести и объединить;
export default function initCompareRowsListeners(storageKey, $resultCompareButtonParent, refreshPageParamsFn) {
    const compareOrganizationIdsInStorage = (new LocalStorage()).get(storageKey);
    let compareOrganizationIds = compareOrganizationIdsInStorage && Array.isArray(compareOrganizationIdsInStorage)
        ? uniq(compareOrganizationIdsInStorage.map((id) => {
            return parseInt(id, 10);
        }))
        : [];
    const $badge = $('.compare-cart__badge');
    const $badgeBottom = $('.compare-cart__title__badge');
    const $bodyWidth = screen.width;
    const desktopWidth = 1200;
    const $addToCompareCartButtons = $('.add-to-compare-cart');
    const isInCartClass = 'add-to-compare-cart__active';

    $addToCompareCartButtons.attr('disabled', false);

    $('.add-to-compare-cart').prop('disabled', storageKey === 'compare.undefined.organizations');

    if (storageKey === 'compare.undefined.organizations' && $bodyWidth < desktopWidth) {
        $('.compare-cart-bottom-panel').show();
        let currentFeedbackBottom = parseInt($('#feedback').css('bottom'));
        let currentPageupBottom = parseInt($('#pageUp').css('bottom'));
        currentFeedbackBottom += 60;
        currentPageupBottom += 60;
        $('#feedback').css('bottom', `${currentFeedbackBottom}px`);
        $('#pageUp').css('bottom', `${currentPageupBottom}px`);
    }

    if (compareOrganizationIds.length) {
        $badge.text(compareOrganizationIds.length);
        $badgeBottom.text(compareOrganizationIds.length);
        $addToCompareCartButtons
            .filter(function () {
                const organizationId = parseInt($(this).attr('data-organization-id'), 10);
                return compareOrganizationIds.includes(organizationId);
            })
            .addClass(isInCartClass)
            .attr('title', lang.remove_from_cart_title);

        $('.compare-cart__btn')
            .attr('disabled', false);

        if ($bodyWidth < desktopWidth)
            $('.compare-cart-bottom-panel').show();
    }

    $resultCompareButtonParent
        .on('click', '.add-to-compare-cart', function () {
            const $addToCompareBtn = $(this);
            const organizationId = parseInt($addToCompareBtn.data('organization-id'), 10);

            const $addToCompareBtns = $('.ranking-tiles').find(`.add-to-compare-cart[data-organization-id='${organizationId}']`);
            if ($addToCompareBtns.length) {
                $addToCompareBtns.each(function () {
                    const $btn = $(this);
                    if ($btn.hasClass(isInCartClass)) {
                        $btn.attr('title', lang.add_to_cart_title);
                        $btn.removeClass(isInCartClass);
                    } else {
                        $btn.attr('title', lang.remove_from_cart_title);
                        $btn.addClass(isInCartClass);
                    }
                });
            }

            if (!$addToCompareBtn.hasClass(isInCartClass)) {
                compareOrganizationIds = difference(compareOrganizationIds, [organizationId]);
            } else {
                compareOrganizationIds.push(organizationId);
            }
            $('.compare-cart__btn').attr('disabled', !Boolean(compareOrganizationIds.length));
            (new LocalStorage()).set(storageKey, compareOrganizationIds);
            $badge.text(compareOrganizationIds.length);
            $badgeBottom.text(compareOrganizationIds.length);
            if (compareOrganizationIds.length && $bodyWidth < desktopWidth) {
                $('.compare-cart-bottom-panel').show();
            } else {
                $('.compare-cart-bottom-panel').hide();
            }
            const compareOrganizationsInUrl = getUrlParameter('organizations');
            if (compareOrganizationsInUrl && compareOrganizationsInUrl.length) {
                reloadPage(compareOrganizationIds);
            }
        });

    $('body')
        .on('click', '.compare-cart__compare-btn', () => {
            return reloadPage(compareOrganizationIds);
        })
        .on('click', '.compare-cart__back-btn', () => {
            window.location.search = refreshPageParamsFn();
        })
        .on('click', '.compare-cart__clear-btn', () => {
            (new LocalStorage()).set(storageKey, []);
            window.location.search = refreshPageParamsFn();
        });

    function reloadPage() {
        const primarySearchQueryString = refreshPageParamsFn();
        window.location.search = `${primarySearchQueryString}&${formQueryString({organizations: compareOrganizationIds})}`;
    }

    window.addEventListener(`resize`, event => {
        const bodyWidth = $('body').width();
        if ((compareOrganizationIds.length || storageKey === 'compare.undefined.organizations') && bodyWidth < desktopWidth) {
            $('.compare-cart-bottom-panel').show();
        } else {
            $('.compare-cart-bottom-panel').hide();
        }
    }, false);
}
